import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { MentoringDocumentModel } from "./mentoring-document-data.model";

export class MentoringDocumentGridPostParams extends GridPostParams {
    student_id: string = ''
}

export class MentoringDocumentGridModel extends MentoringDocumentModel { }

export class MentoringDocumentListingModel extends GridModel<MentoringDocumentGridModel> { }
